import { createSvs } from "react-hook-svs"

export default createSvs((scope, staticData) => {
    /**
     * Given staticData, we can import Gatherings or
     * do something with page titles and descriptions
     */
    return {}
})
